import React from 'react';

import { Menu, MenuItem, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { TabIcon } from './tab-icon';
import type { Tab } from './tab-types';

const useStyles = makeStyles()(theme => ({
  icon: {
    flexShrink: 0,
    marginRight: theme.spacing(1),
  },
  label: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

interface TabOverflowMenuProps {
  activeTabId: UUID | null;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onSwitchToTab: (tabId: UUID) => void;
  tabs: Tab[];
}

export function TabOverflowMenu({
  activeTabId,
  anchorEl,
  onClose,
  onSwitchToTab,
  tabs,
}: TabOverflowMenuProps): JSX.Element {
  const { classes } = useStyles();

  return (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      open={Boolean(anchorEl)}
      slotProps={{ paper: { sx: { maxHeight: 400 } } }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      onClose={onClose}
    >
      {tabs.map(tab => (
        <MenuItem
          key={tab.id}
          dense
          selected={tab.id === activeTabId}
          onClick={() => {
            onSwitchToTab(tab.id);
            onClose();
          }}
        >
          <span className={classes.icon}>
            <TabIcon type={tab.type} />
          </span>
          <Typography className={classes.label} component="span" variant="body2">
            {tab.title}
          </Typography>
        </MenuItem>
      ))}
    </Menu>
  );
}
